import { render, staticRenderFns } from "./RegistroEspecialidades.vue?vue&type=template&id=5c481148&scoped=true&"
import script from "./RegistroEspecialidades.vue?vue&type=script&lang=js&"
export * from "./RegistroEspecialidades.vue?vue&type=script&lang=js&"
import style0 from "./RegistroEspecialidades.vue?vue&type=style&index=0&id=5c481148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c481148",
  null
  
)

export default component.exports